var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCorporateUploadImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.666 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0z",
    fill: "url(#6ofq0d11na)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.69 6.21a72.862 72.862 0 0 1 12.62 0l2.014.177a4.184 4.184 0 0 1 3.775 3.546 40.803 40.803 0 0 1 0 12.134 4.184 4.184 0 0 1-3.775 3.546l-2.013.175a72.8 72.8 0 0 1-12.62 0l-2.014-.175a4.184 4.184 0 0 1-3.776-3.546 40.802 40.802 0 0 1 0-12.134 4.184 4.184 0 0 1 3.775-3.546l2.015-.176zm12.447 1.994a70.861 70.861 0 0 0-12.274 0l-2.014.175a2.184 2.184 0 0 0-1.969 1.85 38.802 38.802 0 0 0-.415 6.894l5.162-5.163a1 1 0 0 1 1.453.043l4.896 5.506 3.373-1.125a1 1 0 0 1 1.062.28l4.692 5.213c.592-3.86.598-7.786.018-11.648a2.184 2.184 0 0 0-1.97-1.85l-2.014-.175zm2.69 15.247-4.466-4.962-3.378 1.126a1 1 0 0 1-1.064-.284l-4.628-5.207-5.659 5.657c.065.664.147 1.328.247 1.988a2.184 2.184 0 0 0 1.97 1.852l2.014.175c4.084.355 8.19.355 12.274 0l2.014-.175c.237-.02.466-.08.676-.17z",
    fill: "url(#j0hmw18pnb)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "6ofq0d11na",
    x1: 21.635,
    y1: 16.143,
    x2: 17.557,
    y2: 14.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j0hmw18pnb",
    x1: 22.076,
    y1: 36.843,
    x2: -1.752,
    y2: 25.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateUploadImage);
export default __webpack_public_path__ + "static/media/corporateUploadImage.8cf954c345773871433d5f9d8bdedd5e.svg";
export { ForwardRef as ReactComponent };